import "./MapZoomIndicator.css";

export interface MapZoomIndicatorProps {
    zoom: number;
    aggregationThreshold?: number;
    showAggregationInfo?: boolean;
    /**
     * Overrides the label for what the map is currently drawing. A campaign view below the
     * threshold no longer falls back to the aggregation grid — it loads delivered points for
     * the whole kommun instead — so the caller says which of the two it is.
     */
    modeLabel?: string;
}

export const MapZoomIndicator = ({
    zoom,
    aggregationThreshold = 14,
    showAggregationInfo = true,
    modeLabel
}: MapZoomIndicatorProps): JSX.Element => {
    const isUsingAggregations = zoom < aggregationThreshold;

    return (
        <div className="map-zoom-indicator">
            <div className="map-zoom-indicator__zoom">
                <span className="map-zoom-indicator__label">Zoom:</span>
                <span className="map-zoom-indicator__value">{zoom.toFixed(2)}</span>
            </div>
            {showAggregationInfo && (
                <div className={`map-zoom-indicator__mode ${isUsingAggregations ? "map-zoom-indicator__mode--aggregations" : "map-zoom-indicator__mode--individual"}`}>
                    {modeLabel ?? (isUsingAggregations ? "Aggregations" : "Individual Points")}
                </div>
            )}
            <div className="map-zoom-indicator__threshold">
                Threshold: {aggregationThreshold}
            </div>
        </div>
    );
};